<template>
    <div class="customzf">
       <div class="customzf_top">
        <div class="customzf_top_container">
            <div class="flex between">
            {{ goodsInfo.goods_name }}
            <div class="size25" @click="closePopup">×</div>
            </div>
            <div class="flex start">
                <img :src="goodsInfo.original_img"  :onerror="Imgerror" class="popup-shopimg-small" alt="">
                <div class="info ml10 size12 weight">
                    <p>双方合同协定商品价格为￥{{ cost_price }}</p>
                    <p>需交由平台4.75%销售费用</p>
                    <p>待支付：<span class="size18 Con">￥{{ total_amount }}</span></p>
                </div>
            </div>
        </div>
        
       </div>
       <div class="customzf_box">
        <div class="customzf_box_container">
            <div class="flex between mb5" v-for="item,index in list" :key="index">
                <div class="flex ">
                    <p class="mr15 spec">{{ item.label }}</p>
                    <p class="Con">￥{{ calculatedValues[index] }}</p>
                </div>
                <img class="status" @click="tabItem(index)" v-if="!item.is_active" src="@/assets/img/custom.png" alt="">
                <img class="status" v-else src="@/assets/img/custom1.png" alt="">
                
            </div>
        </div>
       </div>
       <div class="customzf_bottom flex center">
        <button @click="handleZf">支付</button>
       </div>
    </div>
</template>

<script>
export default {
    props:{
        goodsInfo:{
            type:Object,
            default:()=>{},
        }
    },
    data(){
        return{
            list:[
                {id:1,label:'01级',coefficient:1,is_active:true},
                {id:2,label:'02级',coefficient:2,is_active:false},
                {id:3,label:'03级',coefficient:3,is_active:false},
                {id:4,label:'04级',coefficient:4,is_active:false},
                {id:5,label:'05级',coefficient:5,is_active:false},
                {id:6,label:'06级',coefficient:6.22,is_active:false},
                {id:7,label:'07级',coefficient:8.29,is_active:false},
                {id:8,label:'08级',coefficient:10.36,is_active:false},
                {id:9,label:'09级',coefficient:12.43,is_active:false},
                {id:10,label:'10级',coefficient:14.92,is_active:false},
                {id:11,label:'11级',coefficient:17.91,is_active:false},
                {id:12,label:'12级',coefficient:21.49,is_active:false},
                {id:13,label:'13级',coefficient:25.79,is_active:false},
                {id:14,label:'14级',coefficient:30.09,is_active:false},
                {id:15,label:'15级',coefficient:34.39,is_active:false},
                {id:16,label:'16级',coefficient:38.69,is_active:false},
            ],
            cost_price:0,
            total_amount:''
        }
    },
    created(){
        this.cost_price = this.goodsInfo['cost_price']
        this.total_amount = (this.list[0].coefficient * 1.0475 * this.cost_price).toFixed(2)
    },
    computed: {
        calculatedValues() {
        return this.list.map(item => (item.coefficient * 1.0475 * this.cost_price).toFixed(2));
        },
    },
    methods:{
        tabItem(index){
            this.total_amount = (this.list[index].coefficient * 1.0475 * this.goodsInfo.cost_price).toFixed(2)
            this.list.forEach(item => item.is_active = false)
            this.list[index].is_active = true
        },
        closePopup(){
            this.$emit("closeJs");
        },
        handleZf(){
            this.$emit('totalAmount',this.total_amount)
        }
    },
    watch:{
        deep:true,
        goodsInfo(newval){
            this.cost_price = newval['cost_price']
            this.total_amount = (this.list[0].coefficient * 1.0475 * this.cost_price).toFixed(2)
            this.list.forEach(item => item.is_active = false)
            this.list[0].is_active = true
        }
    }
}
</script>

<style lang="scss" scoped>
.customzf{
    position: relative;
    .customzf_top{
        position: fixed;
        top: 10vh;
        left: 0;
        // position: absolute;
        // top: 0;
        width: 100%;
        height: 25%;
        padding: 10px 0;
        background-color: #fff;
        overflow: hidden;
        .customzf_top_container{
            padding: 0 15px;
        }
    }
    .customzf_box{
        padding-top: 25%;
        padding-bottom: 80px;
        .customzf_box_container{
            padding: 0 15px;
            padding-top: 25%;
        }
        .spec{
            width: 26.1333vw;
            height: 8vw;
            line-height: 8vw;
            text-align: center;
            color: #999999;
            font-size: 14px;
            background: #f6f6f6;
            border-radius: 0.5333vw;
        }
    }
}
.status{
    width: 4vw;
}

.popup-shopimg-small {
    display: block;
    width: 30%;
    object-fit: contain;
}

.customzf_bottom{
    position: fixed;
    height: 17.0667vw;
    padding: 0 4vw;
    bottom: 0;
    left: 0;
    right: 0;
    background: #ffffff;
    box-shadow: 0px -1px 20px 0px rgba(0, 0, 0, 0.08);
    justify-content: flex-end;
    button {
        width: 23.2vw;
        height: 10.6667vw;
        line-height: 10.6667vw;
        text-align: center;
        background: #e30000;
        border-radius: 5.6vw;
        font-size: 14px;
        color: #fff;
        border: 1px solid #e30000;
    }
}


</style>